import api from "../api";

const orderCollection = (storeCode) =>
  `${process.env.REACT_APP_API_ENDPOINT || ""}/api/management/stores/${encodeURIComponent(storeCode)}/orders`;

export const listManagementOrders = async ({ storeCode, ...params }) => {
  const response = await api.get(orderCollection(storeCode), { params });
  return response.data;
};

export const retryOrderInvoice = async ({ storeCode, orderId }) => {
  const response = await api.post(
    `${orderCollection(storeCode)}/${encodeURIComponent(orderId)}/invoice/retry`
  );
  return response.data;
};
